import { HashRouter, BrowserRouter, Route, Routes } from "react-router-dom";
import About from "../Pages/About";
import Home from "../Pages/Home";
import HowItWorks from "../Pages/HowItWorks";
import PropertyList from "../Pages/PropertyList";

import Blog from "../Pages/Blog";
import BlogArticle from "../Pages/BlogArticle";
import Contact from "../Pages/Contact";
import Invest from "../Pages/Invest";
import InvestmentSummary from "../Pages/InvestmentSummary.js";
import Projects from "../Pages/Projects";
import PropertyDetails from "../Pages/PropertyDetails";
import Signup from "../Pages/Signup";
import ScrollToTop from "./ScrollToTop";

import AddProject from "../Admin/AddProject";
import AddUser from "../Admin/AddUser";
import ProjectSave from "../Admin/ProjectSave";
import UserList from "../Admin/UserList";
import UserVerify from "../Admin/UserVerify";
import DocumentsUpload from "../Pages/DocumentsUpload";
import ForgotPassword from "../Pages/ForgotPassword";
import ForgotPasswordEmail from "../Pages/ForgotPasswordEmail";
import Login from "../Pages/Login";
import Otp from "../Pages/Otp";
import Payment from "../Pages/Payment";
import NewPassword from "../Pages/NewPassword";
import MyAccount from "../Pages/MyAccount";
import OrderConfirmed from "../Pages/OrderConfirmed";
import OrdersHistory from "../Pages/OrdersHistory";
import ProfileEdit from "../Pages/ProfileEdit";
import InvestmentProjects from '../Pages/InvestmentProjects';
import CommercialProjects from '../Pages/CommercialProjects';
import ResidentialPlots from '../Pages/ResidentialPlots';
import ResidentialLand from '../Pages/ResidentialLand';



import Dashboard from '../Admin/Dashboard';
import Orders from '../Admin/Orders';
import Reports from '../Admin/Reports';
// import PractitionerList from '../Admin/ProjectsList';
import OrdersAssigned from '../Admin/OrdersAssigned';

import Users from '../Admin/Users';
import ProjectsList from "../Admin/ProjectsList";
import PropertyType from "../Admin/PropertyType";
import EditUser from "../Admin/EditUser";
import ViewUser from "../Admin/ViewUser";
import InvestmentList from "../Admin/InvestmentList";
import AddInvestment from "../Admin/AddInvestment";
import EditInvestment from "../Admin/EditInvestment";
import ViewInvestment from "../Admin/ViewInvestment";
import EditUserVerify from "../Admin/EditUserVerify";
import ViewProject from "../Admin/ViewProject";
import EditProject from "../Admin/EditProject";
import EditProjectSave from "../Admin/EditProjectSave";
// import UserList1 from '../Admin/UserList';

export default function RouterPage() {
  return (
    <div>
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<Home />}></Route>
          <Route path="/how-it-works" exact element={<HowItWorks />}></Route>
          <Route path="/about" exact element={<About />}></Route>
          <Route path="/properties" exact element={<PropertyList />}></Route>
          <Route path="/projects" exact element={<Projects />}></Route>
          <Route path="/invest" exact element={<Invest />}></Route>
          <Route path="/contact" exact element={<Contact />}></Route>
          <Route
            path="/property-details"
            exact
            element={<PropertyDetails />}
          ></Route>
          <Route
            path="/investment-summary"
            exact
            element={<InvestmentSummary />}
          ></Route>
          <Route path="/blog" exact element={<Blog />}></Route>
          <Route path="/blog-article" exact element={<BlogArticle />}></Route>
          <Route path="/signup" exact element={<Signup />}></Route>
          <Route path="/login" exact element={<Login />}></Route>

          <Route path="/new-password" exact element={<NewPassword />}></Route>
       
          <Route path='/investment-projects' exact element={<InvestmentProjects/>}></Route>
              <Route path='/commercial-projects' exact element={<CommercialProjects/>}></Route>
              <Route path='/residential-plots' exact element={<ResidentialPlots/>}></Route>
              <Route path='/residential-land' exact element={<ResidentialLand/>}></Route>
          <Route
            path="/documents-upload"
            exact
            element={<DocumentsUpload />}
          ></Route>
          <Route
            path="/forgot-password"
            exact
            element={<ForgotPassword />}
          ></Route>
          <Route
            path="/forgot-password-email"
            exact
            element={<ForgotPasswordEmail />}
          ></Route>
          <Route path="/otp" exact element={<Otp />}></Route>
          <Route path="/payment" exact element={<Payment />}></Route>


{/* added paths */}
          <Route path="/my-account" exact element={<MyAccount />}></Route>
          <Route path="/order-confirmed" exact element={<OrderConfirmed />}></Route>
          <Route path="/order-history" exact element={<OrdersHistory />}></Route>
          <Route path="/edit-profile" exact element={<ProfileEdit/>}></Route>
          {/* <Route path='/userlist1' exact element={<UserList1/>}></Route> */}


          <Route path='/property-type' element={<PropertyType/>}></Route>
          <Route path='/projects-list' element={<ProjectsList/>}></Route>
          <Route path='/users' element={<Users/>}></Route>
       
          <Route path='/admin-dashboard' element={<Dashboard/>}></Route>
          <Route path="/add-project" exact element={<AddProject />}></Route>
          <Route path="/view-project" exact element={<ViewProject />}></Route>
          <Route path="/edit-project" exact element={<EditProject />}></Route>
          <Route path="/edit-project-save" exact element={<EditProjectSave />}></Route>
          <Route path="/project-save" exact element={<ProjectSave />}></Route>
          <Route path="/add-user" exact element={<AddUser />}></Route>
          <Route path="/edit-user" exact element={<EditUser />}></Route>
          <Route path="/view-user" exact element={<ViewUser />}></Route>
          <Route path="/verify-user" exact element={<UserVerify />}></Route>
          <Route path='/edit-user-verify' element={<EditUserVerify/>}></Route>
          <Route path="/userlist" exact element={<UserList />}></Route>
          <Route path='/orders-assigned' element={<OrdersAssigned/>}></Route>
          <Route path='/orders' element={<Orders/>}></Route>
          <Route path='/reports' element={<Reports/>}></Route>
          <Route path='/investment' element={<InvestmentList/>}></Route>
          <Route path='/add-investment' element={<AddInvestment/>}></Route>
          <Route path='/edit-investment' element={<EditInvestment/>}></Route>
          <Route path='/view-investment' element={<ViewInvestment/>}></Route>
        </Routes>
      </HashRouter>
    </div>
  );
}
